import { DrawerNavLink, Routes } from 'types/global.type';

export const drawerNavLinks: DrawerNavLink[] = [
  { title: 'PRODUCT', to: Routes.product },
  { title: 'ABOUT', to: Routes.about },
  { title: 'CONTACT', to: Routes.contact },
  { title: 'BLOG', to: Routes.blog },
  { title: 'SIGN-IN', to: Routes.login },
];
